// Casillas/selects/campos (`CamposSimples`) más las áreas de texto con dictado de un bloque de campos — reutilizado por
// las anamnesis 002/003 (Fase 7, Tanda 17), donde cada bloque del papel es "casillas + Describa".
import type { JSX } from 'react';
import { AreaDictado } from './AreaDictado';
import { CamposSimples } from './camposSimples';
import type { CampoSimple, Valores } from './camposSimplesDatos';

export interface SeccionCamposProps {
  readonly prefijoId: string;
  readonly campos: readonly CampoSimple[];
  readonly valores: Valores;
  readonly onChange: (valores: Valores) => void;
  readonly columnas?: 2 | 3 | 4;
  readonly filasArea?: number;
}

export function SeccionCampos({ prefijoId, campos, valores, onChange, columnas = 3, filasArea = 3 }: SeccionCamposProps): JSX.Element {
  const simples = campos.filter((c) => c.tipo !== 'area');
  return (
    <>
      {simples.length > 0 && <CamposSimples prefijoId={prefijoId} campos={simples} valores={valores} columnas={columnas} onChange={(v) => onChange({ ...valores, ...v })} />}
      {campos
        .filter((c) => c.tipo === 'area')
        .map((c) => (
          <AreaDictado key={c.clave} id={`${prefijoId}-${c.clave}`} etiqueta={c.etiqueta} valor={valores[c.clave] ?? ''} filas={filasArea} onChange={(v) => onChange({ ...valores, [c.clave]: v })} />
        ))}
    </>
  );
}
